import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/auth/store'
import pages from '@/modules/pages/store'
import blog from '@/modules/blog/store'
import press from '@/modules/press/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: auth,
    pages: pages,
    blog: blog,
    press: press
  },
  state: {
    layout: 'default-layout'
  },
  mutations: {
    SET_LAYOUT (state, layout) {
      state.layout = layout
    }
  },
  getters: {
    layout (state) {
      return state.layout
    }
  },
  actions: {
    //
  }
})
